import SyoApp from "./classes/syo-app";

// global window defines
declare global {
    interface Window {
        //future stuff
        syoApp: SyoApp;
    }
}

const globalSyoInit = function () {
    window.syoApp = new SyoApp();
}
globalSyoInit();